import { Component } from '@angular/core';

import { ICellEditorParams, JoinAdvancedFilterModel, NumberAdvancedFilterModel } from 'ag-grid-enterprise';

import { TextBoxComponent } from '@camelot/form-input';

import { BaseEditorComponent } from '../base-col';
import type { CurrencyCol } from './currency-col';

@Component({
  host: { 'data-cid': 'currency-editor' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [TextBoxComponent],
  template: ` @if (this.input) {
    <cam-input-textbox
      [input]="$any(this.input)"
      [standalone]="true"
      [onFocus]="this.focus$"
      (valueChanged)="this.applyInputValue($event)"
    ></cam-input-textbox>
  }`,
})
export class CurrencyEditorComponent extends BaseEditorComponent<
  JoinAdvancedFilterModel | NumberAdvancedFilterModel,
  CurrencyCol,
  Number
> {
  override agInit(params: ICellEditorParams) {
    super.agInit(params);
  }

  getValue() {
    return Number(this.input?.value) ?? null;
  }
}
